import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isOpen]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${isOpen ? 'menu-open' : ''}`}>
      <div className="navbar-container">
        
        {/* LOGO BÖLÜMÜ */}
        <Link to="/" className="nav-logo" onClick={() => setIsOpen(false)}>
          <span className="subtitle">Çocuk Cerrahisi Uzmanı</span>
          <h1 className="doctor-name">Op. Dr. <span>Mahmut</span> Aluç</h1>
        </Link>

        {/* MASAÜSTÜ NAV */}
        <div className="nav-desktop">
          <ul className="desktop-links">
            <li><Link to="/">Ana Sayfa</Link></li>
            <li><Link to="/hakkimizda">Hakkımızda</Link></li>
                        <li><Link to="/whyUsSection">Neden Çocuk Cerrahi</Link></li>

            <li><Link to="/uzmanliklar">Uzmanlıklar</Link></li>
            <li><Link to="/iletisim">İletişim</Link></li>

          </ul>
          {/* Masaüstü Randevu Butonu Yönlendirmesi */}
          <Link to="/randevu-al" className="appointment-btn">Randevu Al</Link>
        </div>

        {/* HAMBURGER BUTON */}
        <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {/* MOBİL MENÜ OVERLAY */}
        <div className={`nav-mobile-overlay ${isOpen ? 'active' : ''}`}>
          <ul className="mobile-links">
            <li style={{ "--i": 1 }}><Link to="/" onClick={() => setIsOpen(false)}>Ana Sayfa</Link></li>
            <li style={{ "--i": 2 }}><Link to="/hakkimizda" onClick={() => setIsOpen(false)}>Hakkımızda</Link></li>
                                    <li style={{ "--i": 5 }}><Link to="/whyUsSection" onClick={() => setIsOpen(false)}>Neden Çocuk Cerrahi</Link></li>

            <li style={{ "--i": 3 }}><Link to="/uzmanliklar" onClick={() => setIsOpen(false)}>Uzmanlıklar</Link></li>
            <li style={{ "--i": 4 }}><Link to="/iletisim" onClick={() => setIsOpen(false)}>İletişim</Link></li>


            <li style={{ "--i": 5 }}>
              {/* Mobil Randevu Butonu Yönlendirmesi */}
              <Link 
                to="/randevu-al" 
                className="appointment-btn mobile-apt-btn" 
                onClick={() => setIsOpen(false)}
              >
                Randevu Al
              </Link>
            </li>
          </ul>
        </div>

      </div>
    </nav>
  );
};

export default Navbar;